import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-ssdf-call-dashboard-batch',
  templateUrl: './ssdf-call-dashboard-batch.component.html',
  styleUrls: ['./ssdf-call-dashboard-batch.component.scss']
})
export class SsdfCallDashboardBatchComponent implements OnInit {
  @Input() generalData: any;
  @Input() appForDay: any;
  @Input() batchData: any;
  @Input() fundingNeedPieData: any;
  @Input() fundingNeedBarData: any;
  @Input() appForPremoney: any;
  @Input() appForRegion: any;
  constructor() { }

  ngOnInit(): void {
  }

}
